import { ConfigValueType } from '../../types'

export const getConfigValue = (value: ConfigValueType | undefined): string | number | undefined =>
  typeof value === 'function' ? value() : value
